import { IconsProps } from '@/types/shared'
import React from 'react'

const DownIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.41 16.205L12 11.625L16.59 16.205L18 14.795L12 8.79504L6 14.795L7.41 16.205Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default DownIcons
